export const environment = {
    production: true,
    endpoint: () => 'https://api.hellius.atmansystems.com',
    uri: () => encodeURI(window.location.origin),
    atmanLogo: true,
    softwareName: 'Hellius',
    _AUTHORIZATION_HASH: 'a557eb4c08ee97f6708123af45e8ea37bbcf8c7769eec48de67653bd32ce1391',
  };
  